var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"padded-space",attrs:{"id":"trade-view"}},[_c(_setup.OnBehalfOf,{attrs:{"clientId":_vm.clientId}},[_c(_setup.OptionCreator,{on:{"trade-created":_setup.onTradeCreated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }